import axios from 'axiosInstance';
import { REQUESTED_DATA_STATUS } from 'admin/constants';
import { callApi } from 'utils';

export const TYPES = {
  GET_RISK_TYPE_DESCRIPTION: 'GET_RISK_TYPE_DESCRIPTION',
  GET_RISK_TYPE_DESCRIPTION_SUCCESS: 'GET_RISK_TYPE_DESCRIPTION_SUCCESS',
  GET_RISK_TYPE_DESCRIPTION_ERROR: 'GET_RISK_TYPE_DESCRIPTION_ERROR',
};

export const getRiskTypeDescription = id =>
  callApi({
    types: {
      pending: TYPES.GET_RISK_TYPE_DESCRIPTION,
      success: TYPES.GET_RISK_TYPE_DESCRIPTION_SUCCESS,
      error: TYPES.GET_RISK_TYPE_DESCRIPTION_ERROR,
    },
    request: () =>
      axios.post('/risks/metadata/incident-risk/query/', {
        body: JSON.stringify({
          columns: [
            'id',
            'risk_type',
            'risk_sub_category',
            'risk_category',
            'definition',
            'minor',
            'moderate',
            'severe',
            'extreme',
          ],
          filters: [
            {
              name: 'risk_type_id',
              operator: '==',
              value: id,
            },
          ],
        }),
      }),
  });

const INITIAL_STATE = {
  status: undefined,
  riskTypeDescriptions: [],
  error: undefined,
};

export const riskTypeDescriptionsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.GET_RISK_TYPE_DESCRIPTION:
      return {
        ...state,
        status: REQUESTED_DATA_STATUS.PENDING,
        error: undefined,
        params: action.payload,
      };
    case TYPES.GET_RISK_TYPE_DESCRIPTION_SUCCESS:
      return {
        ...state,
        status: REQUESTED_DATA_STATUS.SUCCESS,
        riskTypeDescriptions: action.payload,
        error: undefined,
      };
    case TYPES.GET_RISK_TYPE_DESCRIPTION_ERROR:
      return {
        ...state,
        status: REQUESTED_DATA_STATUS.ERROR,
        error: action.payload,
      };
    default:
      return state;
  }
};
